// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.text[data-v-1518f75c] {\n  text-align: center;\n}\n.typeIcon[data-v-1518f75c] {\n  text-align: center;\n}\n.slotForm[data-v-1518f75c] {\n  padding-top: 0px;\n}\n.infoText[data-v-1518f75c] {\n  padding-bottom: 0px;\n}\n.actions-buttons[data-v-1518f75c], .slotForm[data-v-1518f75c] {\n  align-content: center;\n  justify-content: center;\n}\n.headline[data-v-1518f75c] {\n  padding-top: 30px;\n}\n.actions-buttons[data-v-1518f75c] {\n  padding-bottom: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
